import { SCREEN_PRESENTER } from '@studio/constants';
import { getProgramLayers } from '@studio/program';
import {
  toggleProgramSource,
  decreaseScreenShare,
  cancelDisconnectSource,
  removeAttendeeCamera,
} from '@shoflo/studio-redux/actions';
import { deleteSource } from 'actions/source';
import { setProgram } from 'actions/program';

function removeAttendeeScreen(store, data) {
  const { attendeeId, closedOrReloadTab } = data;
  const { broadcastSources, program } = store.getState();
  const sources = broadcastSources.sources.filter((s) =>
    [attendeeId, `${attendeeId}#content`].includes(s.value)
  );

  const layers = getProgramLayers(program);

  if (sources.length) {
    sources.forEach((source) => {
      const [layerSource] = layers.filter(
        (layer) => layer.source._id === source._id
      );
      // Remove if source is in program
      if (!!layerSource) {
        store.dispatch(toggleProgramSource(source, setProgram));
      }
      store.dispatch(deleteSource(source._id));
      store.dispatch(removeAttendeeCamera(source.value));

      if (source.type === SCREEN_PRESENTER) {
        store.dispatch(decreaseScreenShare());
      }
    });

    if (closedOrReloadTab) {
      // We wait for chime to register that the attendee has left the session
      window.setTimeout(() => {
        sources.forEach((source) => {
          store.dispatch(cancelDisconnectSource(source._id));
        });
      }, 3000);
    }
  }
}

export default removeAttendeeScreen;
